(function () {
    "use strict";

    angular
        .module("app.customer")
        .factory("CustomerGeneralService", CustomerGeneralService);

    CustomerGeneralService.$inject = ["$http", "$q"];

    function CustomerGeneralService($http, $q) {
        var service = {
            getGenders: getGenders,
            getMaritalStatus: getMaritalStatus,
            getEducationalStatus: getEducationalStatus,
            getJobs: getJobs,
            getRemainingTickPrice: getRemainingTickPrice,
        };

        var serviceBase = "/";

        return service;

        function getGenders() {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/user/general/gender")
                .then(getGendersComplete)
                .catch(getGendersFailed);

            function getGendersComplete(response) {
                deferred.resolve(response);
            }

            function getGendersFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getMaritalStatus() {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/user/general/maritalstatus")
                .then(getMaritalStatusComplete)
                .catch(getMaritalStatusFailed);

            function getMaritalStatusComplete(response) {
                deferred.resolve(response);
            }

            function getMaritalStatusFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getEducationalStatus() {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/user/general/educationalstatus")
                .then(getEducationalStatusComplete)
                .catch(getEducationalStatusFailed);

            function getEducationalStatusComplete(response) {
                deferred.resolve(response);
            }

            function getEducationalStatusFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getJobs() {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/user/general/job")
                .then(getJobsComplete)
                .catch(getJobsFailed);

            function getJobsComplete(response) {
                deferred.resolve(response);
            }

            function getJobsFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getRemainingTickPrice() {
            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/remainingTickPrice")
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }
    }
})();
